<template>
  <div class="firstpage" v-loading="loading" @click="close()" :style="showLz ? 'background:#00000080' : ''">
    <!-- <div class="swiper-box" id="topPoint">
      <Firstpage ref="Firstpage" v-bind="$attrs" v-on="$listeners" />
    </div> -->
    <!-- 引入svg图 -->
    <!-- <div style="position: relative;"> -->
    <!-- <img v-if="isAndroid" :src="svg1" />
      <object v-if="!isAndroid" type="image/svg+xml" :data="svg1"></object> -->
    <!--<img :src="bgkv" alt="" srcset=""> -->
    <!-- </div> -->
    <!-- <img v-if="isAndroid" :src="svg2" alt="">
    <img v-if="isAndroid" :src="svg3" alt="" srcset="">
    <img v-if="isAndroid" :src="svg4" alt="" srcset=""> -->
    <div style="position: relative;" ref="pc-block1">
      <video class="topVideo" playsinline disablepictureinpicture x5-playsinline="x5-playsinline" webkit-playsinline="webkit-playsinline" x-webkit-airplay="deny" style="position:absolute;width: 342px; height: 186px;z-index: 999;" :src="videoSrc" loop="false" :poster="imgSrc" muted="false" direction="0" controls="false"></video>
      <img class="topbar" :src="rightBar" alt="">
      <img :src="bg1" alt="" srcset="">
    </div>
    <img :src="bg2" alt="" srcset="">
    <img :src="bg3" alt="" srcset="">
    <img :src="bg4" alt="" srcset="">
    <img :src="bg5" alt="" srcset="">
    <section id="qyPoint">
      <!-- <img :src="svg5" alt="" srcset=""> -->
    </section>
    <img ref="pc-block3" :src="bg6" alt="" srcset="">
    <!-- <object v-if="!isAndroid" type="image/svg+xml" :data="svg2"></object>
      <object v-if="!isAndroid" type="image/svg+xml" :data="svg3"></object>
      <object v-if="!isAndroid" type="image/svg+xml" :data="svg4"></object> -->
   

    <!-- <div class="bgmask" v-if="showLz"></div> -->
    <div class="yy-box" style="position: fixed;bottom: 50px;">
      <!-- <img width="100" height="100" :src="arrow" alt="" srcset=""> -->
      <div class="yy-box-btn">
        <button @click.stop.prevent="liuzi()">预约品鉴</button>
      </div>
    </div>
    <div class="right-btn-box" style="position: fixed;bottom: 120px;right: 10px;">
      <a @click="gotoBlock(3)"><img :src="qy" alt="" srcset=""></a>
      <!-- <a href="#topPoint" :style="!showTopBtn ? 'visibility:hidden':''"><img width="100%" :src="topbtn" alt="" srcset=""></a> -->
      <a @click="gotoBlock(1)" v-show="showTopBtn"><img width="100%" :src="topbtn" alt="" srcset=""></a>
    </div>

    <div class="my-form-box" @click.stop>
      <div class="form-container" :style="showLz ? '' : 'transform: translateY(390px)'">
        <MyForm :clientPosition="clientPosition" @close="close"></MyForm>
      </div>
    </div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey, isAndroid } from "@/utils/utils.js";
import Firstpage from "./Firstpage.vue";
import MyForm from "./sonet-Form.vue";
import $ from 'jquery'
// import myBMap from "@/utils/myBMap";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip: false,
      loading: true,
      rightBar: require("@/assets/images/rightBor.png"),
      arrow: require("@/assets/images/arrow.svg"),
      svg5: "/assets/~/media/images/vehicle/ev5/adv/bg04.png",
      bgkv: "/assets/~/media/images/vehicle/ev5/adv/bgkv.png",
      bg1: "/assets/~/media/images/vehicle/sonet/mainpage/adv/mob1.jpg",
      bg2: "/assets/~/media/images/vehicle/sonet/mainpage/adv/mob2.jpg",
      bg3: "/assets/~/media/images/vehicle/sonet/mainpage/adv/mob3.jpg",
      bg4: "/assets/~/media/images/vehicle/sonet/mainpage/adv/mob4.jpg",
      bg5: "/assets/~/media/images/vehicle/sonet/mainpage/adv/mob5.jpg",
      bg6: "/assets/~/media/images/vehicle/sonet/mainpage/adv/mob6.jpg",
      qy: require("@/assets/images/qy.svg"),
      topbtn: require("@/assets/images/top.svg"),
      imgSrc: '/assets/~/media/images/vehicle/sonet/mainpage/adv/video1.png',
      // bg4: require("@/assets/images/bg04.jpg"),
      showLz: false,
      point: null,
      isAndroid: isAndroid(),
      showTopBtn: false,
      videoSrc: "https://img.kia.cn/content/video/20240424/sonetadv.mp4",
    };
  },
  props: {
    clientPosition: {
      type: Object,
      default: null
    }
  },
  computed: {
    swiperBoxHeight() {
      const imgHeight = 1.3 * window.innerWidth
      console.log(imgHeight + 270 < window.innerHeight);
      if (imgHeight + 270 < window.innerHeight) {
        return (window.innerHeight - 270) + "px"
      } else {
        return imgHeight + "px"
      }
    }
  },
  components: { Firstpage, MyForm },
  mounted: function () {
    setTimeout(() => {
      this.loading = false
    }, 1000);
    window.addEventListener('scroll', this.handleScroll);
    // this.$nextTick(()=>{
    // this.cutLocal()
    // })
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 监听页面滚动事件
    handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.showTopBtn = scrollTop > 0;
    },
    smoothScroll(event) {
      event.preventDefault();

      const targetId = event.currentTarget.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offsetTop = targetElement.offsetTop;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    },
    liuzi() {
      this.showLz = true
    },
    close() {
      this.showLz = false
    },
    gotoBlock(e) {
        // console.log(e);
        // const el = this.$refs[`pc-block${e}`];
        // el.scrollIntoView()
        // if (!this.isPortrait) {
        //     if (!this.isAnimating) {
        //         this.isAnimating = true;
        //         // 在动画结束后将 isAnimating 设置为 false，以便下次点击重新触发动画
        //         setTimeout(() => {
        //             this.isAnimating = false;
        //         }, 1000); // 假设动画持续 3 秒钟
        //     }
        // } else {
        const el = this.$refs[`pc-block${e}`];
        el.scrollIntoView()
        // }
    },
  },
};
</script>

<style lang="scss" scoped>
.firstpage {
  position: relative;
  // height: 100%;
  // padding-bottom: 230px;
  width: 100%;
  overflow-y: auto;
  user-select: none;
  img{
    margin-top: -1px;
  }

  //background-color: #000000;
  .topVideo {
    position: absolute;
    width: 342px;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    top: 20px;
    // border-right: 2px solid #fff;
    // border-bottom: 2px solid #fff;
    // padding: 0px 10px 10px;
    // margin: 0 10px 10px;
  }

  .topbar {
    position: absolute;
    width: 85px;
    height: 85px;
    z-index: 99;
    transform: translateX(-50%);
    top: calc(136 / 375 * 100vw);
    left: calc(330 / 375 * 100vw);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  object {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper-box {
    width: 100%;
    overflow: hidden;
    text-align: center;
  }

  .my-form-box {
    width: 100%;
    // 
    display: flex;
    align-items: flex-end;
    position: fixed;
    bottom: 0;
    border-radius: 10px 10px 0px 0px;
    z-index: 10;

    .form-container {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      transition: transform 0.5s;
    }

    .slide-up {
      transform: translateY(390px);
    }

    // padding: 10px 16px 0;
  }

  .bgmask {
    background: #00000080;
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
}

.yy-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  img {
    width: 24px;
    margin-bottom: 20px;
    animation: tbmove 0.7s infinite;
    // height: ;
  }

  &-btn {
    width: 80%;

    button {
      width: 100%;
      height: 43px;
      border-radius: 24px;
      background-color: #FFFFFFF2;
      color: #05141F;
      border: 1px solid #FFFFFF;
      // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1));
    }
  }
}

.right-btn-box {
  display: flex;
  flex-direction: column;

  img {
    margin-top: 10px;
    width: 44px;
    height: 44px;
  }
}

@keyframes tbmove {
  from {
    margin-bottom: 10px;
  }

  to {
    margin-bottom: 20px;
  }
}
</style>
